import React, { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@fragments";

const Description = forwardRef(function Description({ value, onInput }, ref) {
    const { t } = useTranslation("contentModals");
    const [_value, setValue] = useState(value);

    useEffect(() => {
        onInput(_value);
    }, [_value]);

    return (
        <Input.Text
            ref={ref}
            multiline={true}
            size={1000}
            value={_value}
            label={t("manageContent.fields.description")}
            placeholder={t("manageContent.fields.description")}
            onInput={setValue}
            emoji
            autoScroll
        />
    );
});

export default Description;
